import React from 'react';
import styled from 'styled-components';

import Facebook from '../../icons/facebook.svg';
import Instagram from '../../icons/instagram.svg';
import LinkedIn from '../../icons/linkedin.svg';
import Twitter from '../../icons/twitter.svg';

const Copyright = () => (
  <Wrapper>
    <Container>
      <Label>&copy; {new Date().getFullYear()} Commerce7 Platform Inc.</Label>
      <Links>
        <a href="https://www.instagram.com/commerce7platform/">
          <Instagram alt="Instagram" />
        </a>
        <a href="https://www.facebook.com/commerce7team/">
          <Facebook alt="Facebook" />
        </a>
        <a href="https://twitter.com/commerce7team">
          <Twitter alt="Twitter" />
        </a>
        <a href="https://www.linkedin.com/company/commerce7">
          <LinkedIn alt="LinkedIn" />
        </a>
      </Links>
    </Container>
  </Wrapper>
);

const Wrapper = styled.div`
  border-top: 1px solid rgb(220, 223, 232);
`;

const Container = styled.div`
  max-width: 1700px;
  margin: auto;
  padding: 40px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled.span`
  font-size: var(--font-size-sm);
  color: var(--gray-dark);
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  > a {
    display: flex;
    align-items: center;
    margin-left: 20px;
    ${({ theme }) => `
      @media ${theme.mediumUp} {
        margin-left: 50px;
      }
    `}
  }
`;

export default Copyright;
